import ProductCard, { UnsfItem } from "./ProductCard"

interface BrowseProductsProps {
  title: string
  viewAllLabel: string
  viewAllUrl: string
  items: UnsfItem[]
  i18n: {
    soldout: string
    last_pieces: string
    no_image: string
    pre_sale: string
  }
}

export default function BrowseProducts({
  title,
  viewAllLabel,
  viewAllUrl,
  items,
  i18n,
}: BrowseProductsProps) {
  if (items.length === 0) return null

  return (
    <section className="py-16 md:py-24 bg-light">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl md:text-4xl font-bold text-contrast mb-12">
          {title}
        </h2>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {items.map((item) => (
            <ProductCard key={item.id} item={item} i18n={i18n} />
          ))}
        </div>
        <div className="text-center">
          <a
            href={viewAllUrl}
            className="rounded-md inline-block border border-contrast text-contrast px-8 py-3 text-sm font-medium hover:bg-contrast hover:text-light transition-colors"
          >
            {viewAllLabel}
          </a>
        </div>
      </div>
    </section>
  )
}
